import LegacyFocusLayout from '@perpay-web/components/composite/LegacyFocusLayout/LegacyFocusLayout';
import checkmarkCoin from '@perpay-web/fintech/assets/images/illustrations/checkmarkCoin.svg';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import ResponsiveContent from '@perpay-web/fintech/components/base/ResponsiveContent/ResponsiveContent';
import ResponsiveCopy from '@perpay-web/fintech/components/base/ResponsiveCopy/ResponsiveCopy';
import ResponsiveHeader from '@perpay-web/fintech/components/base/ResponsiveHeader/ResponsiveHeader';
import { paths } from '@perpay-web/fintech/props/appPaths';

import styles from './CardUploadDocumentsSuccess.scss';

const CardUploadDocumentsSuccess = ({
    onClickDashboard,
    dashboardURL = paths.dashboard.path,
}) => (
    <LegacyFocusLayout
        className={styles.container}
        footer={
            <CardCta
                Component={CustomLink}
                onClick={onClickDashboard}
                href={dashboardURL}
                className={styles['footer-button']}
                size='large'
            >
                Dashboard
            </CardCta>
        }
    >
        <div className={styles['inner-container']}>
            <ResponsiveContent height={130}>
                <img
                    className={styles.illustration}
                    src={checkmarkCoin}
                    alt='A checkmark on a 3D coin'
                />
            </ResponsiveContent>
            <ResponsiveHeader className={styles.header}>
                Your documents have been uploaded!
            </ResponsiveHeader>
            <ResponsiveCopy className={styles.copy}>
                We will let you know once we have an update on your application.
                This step usually takes 1-2 business days.
            </ResponsiveCopy>
        </div>
    </LegacyFocusLayout>
);

export default CardUploadDocumentsSuccess;
